
export const apiBaseUrl = 'https://api.biathlonhub.com/';
